"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.caseOf = void 0;

var caseOf = function caseOf(cases) {
  return function (someCaseFrom) {
    return function (value) {
      if (!Object.prototype.hasOwnProperty.call(cases, 'defaultCase')) throw new Error('Expected cases to include a default case, but none was provided.');
      var someCase = someCaseFrom(value);
      return Object.prototype.hasOwnProperty.call(cases, someCase) ? cases[someCase](value) : cases.defaultCase(value);
    };
  };
};

exports.caseOf = caseOf;
//# sourceMappingURL=index.js.map